import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faEdit, faTrash, faMagnifyingGlass, faGem } from "@fortawesome/free-solid-svg-icons";
import { Button, Input, Card, Checkbox, CardBody, Chip } from "@heroui/react";
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks";
import { apiRoute, ENUM_CURRENCY_SETTING_VAL, linksUrl } from "../../constants/enum";
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from "../../components";
import { COLUMN_ALIGN_TYPE, COLUMN_TYPE, ROW_ACTION_BTN_TYPE } from "../../components/NextUITable";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
const PacketInformationReport = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const { compCode, compName, CurrencySetting } = useSelector((state) => state.company);
    const [lotNo, setLotNo] = useState("")
    const [pktNo, setPktNo] = useState("")
    const [isMfgNo, setIsMfgNo] = useState(false)
    const [pktData, setPktData] = useState([])


    // Fetch  data
    const {
        data = [],
        isPending,
        isError,
        mutate: filterData,
    } = usePost({
        url: apiRoute.stockEntry.fetchPacketInfo,
        queryKey: "fetchPacketInfo",
        onSuccessTasks: (data) => {
            if (data && Object.keys(data).length > 0) {
                setPktData(data.pktData)
            }

        }
    });

    const funLoadData = (isMfgNo) => {
        filterData({
            data: {
                comp_code: compCode.join(","), lot_no: lotNo, pkt_no: pktNo, trade_of: 'P', is_mfgno: isMfgNo ? 1 : 0
            }
        })
    }
    const handleChkChange = (val) => {
        setIsMfgNo(val)
        funLoadData(val)

    }


    const exportPDF = () => {
        const doc = new jsPDF("p", "mm", "a4");

        const companyName = compName.join(",");
        const today = new Date().toLocaleDateString("en-GB");

        const reportTitle = `Packet Stock & History Report (${today})`;

        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        /* =========================
           HEADER (ALL PAGES)
        ========================= */
        const drawHeader = () => {
            doc.setFontSize(14);
            doc.setFont("helvetica", "bold");
            doc.text(companyName, pageWidth / 2, 12, { align: "center" });

            doc.setFontSize(11);
            doc.text(reportTitle, pageWidth / 2, 18, { align: "center" });

            doc.setLineWidth(0.5);
            doc.line(10, 22, pageWidth - 10, 22);
        };

        /* =========================
           FOOTER (ALL PAGES)
        ========================= */
        const drawFooter = (pageNo, totalPages) => {
            doc.setFontSize(9);
            doc.setFont("helvetica", "normal");

            doc.text(
                `Page ${pageNo} of ${totalPages}`,
                pageWidth - 15,
                pageHeight - 10,
                { align: "right" }
            );

            doc.text(
                `Generated on : ${new Date().toLocaleDateString()}`,
                10,
                pageHeight - 10
            );
        };

        drawHeader();

        let startY = 28;

        /* =========================
           LOT / PACKET INFO
        ========================= */
        autoTable(doc, {
            startY,
            body: [[
                { content: isMfgNo ? "MFG Lot No :" : "Lot No :", styles: { fontStyle: "bold" } },
                lotNo,
                { content: isMfgNo ? "MFG Packet No :" : "Packet No :", styles: { fontStyle: "bold" } },
                pktNo
            ]],
            theme: "grid",
            styles: {
                fontSize: 10,
                cellPadding: 3
            }
        });


        startY = doc.lastAutoTable.finalY + 5;

        /* =========================
           STOCK DATA
        ========================= */
        data?.stkData?.forEach((ele) => {
            autoTable(doc, {
                startY,
                body: [
                    // Stock Summary row spanning all 8 columns
                    [
                        { content: "Stock Summary", colSpan: 8, styles: { halign: "center", fontStyle: "bold" } }
                    ],
                    // Item row
                    [
                        { content: "Item", styles: { fontStyle: "bold" } },
                        ele.ItemName,
                        { content: "Shape", styles: { fontStyle: "bold" } },
                        ele.ShapeName,
                        { content: "Size", styles: { fontStyle: "bold" } },
                        ele.BWeight,
                        { content: "Rate", styles: { fontStyle: "bold" } },
                        `${ele.BRate > 0 ? ele.BRate.toFixed(2) : ""}${ele.BRated > 0 ? " | $" + ele.BRated.toFixed(2) : ""}`
                    ],
                    // Location row
                    [
                        { content: "Location", styles: { fontStyle: "bold" } },
                        ele.StkAtName,
                        { content: "Color", styles: { fontStyle: "bold" } },
                        ele.ColorName,
                        { content: "Purity", styles: { fontStyle: "bold" } },
                        ele.PurityName,
                        { content: "Lab", styles: { fontStyle: "bold" } },
                        ele.LabName
                    ],
                    [
                        { content: "Certi No", styles: { halign: "center", fontStyle: "bold" } }, ele.ReportNo
                        // { content: "Video Link",   styles: { halign: "center", fontStyle: "bold" } },ele.VideoFile
                    ]
                ],
                theme: "grid",
                styles: {
                    fontSize: 9,
                    cellPadding: 2
                },
                didDrawPage: drawHeader
            });


            startY = doc.lastAutoTable.finalY + 5;
        });

        /* =========================
           PACKET HISTORY TABLE
        ========================= */
        if (pktData?.length > 0) {
            autoTable(doc, {
                startY,
                head: [
                    CurrencySetting && CurrencySetting != 'RS' ? ["#", "Process", "Date", "Party", "Weight", "Rate($)", "Amount($)", "Rate", "Amount",]
                        : ["#", "Process", "Date", "Party", "Weight", "Rate($)", "Amount($)", "Rate", "Amount"
                        ]],
                body: pktData.map((ele, i) => ([
                    i + 1,
                    ele.EntryType,
                    new Date(ele.EDate).toLocaleDateString(),
                    ele.PartyName || "-",
                    ele.Weight,
                    CurrencySetting && CurrencySetting != 'RS' ? ele.RateD > 0 ? ele.RateD.toFixed(2) : "-" : "",
                    CurrencySetting && CurrencySetting != 'RS' ? ele.AmountD > 0 ? ele.AmountD.toFixed(2) : "-" : "",
                    ele.Rate > 0 ? ele.Rate.toFixed(2) : "-",
                    ele.Amount > 0 ? ele.Amount.toFixed(2) : "-",
                ])),
                theme: "grid",
                styles: {
                    fontSize: 9,
                    cellPadding: 2
                },
                headStyles: {
                    fillColor: [219, 234, 254],
                    textColor: [30, 64, 175]
                },
                didDrawPage: drawHeader
            });
        }

        /* =========================
           FOOTER ON EACH PAGE
        ========================= */
        const totalPages = doc.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            drawFooter(i, totalPages);
        }

        doc.save(`Lot-${lotNo}_Pkt-${pktNo}.pdf`);
    };
    const exportExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Packet Report");
        const today = new Date().toLocaleDateString("en-GB");
        /* =========================
           DEFAULT STYLES
        ========================= */
        worksheet.properties.defaultRowHeight = 20;
        worksheet.columns = [
            { width: 8 },
            { width: 20 },
            { width: 12 },
            { width: 20 },
            { width: 12 },
            { width: 12 },
            { width: 12 },
            { width: 12 },
        ];

        let rowIndex = 1;

        /* =========================
           COMPANY NAME
        ========================= */
        const companyRow = worksheet.getRow(rowIndex++);
        companyRow.getCell(1).value = compName.join(",");
        companyRow.height = 25;
        companyRow.getCell(1).font = { bold: true, size: 16 };
        worksheet.mergeCells(`A${companyRow.number}:H${companyRow.number}`);
        companyRow.getCell(1).alignment = { vertical: "middle", horizontal: "center" };

        /* =========================
           REPORT TITLE
        ========================= */
        const titleRow = worksheet.getRow(rowIndex++);
        titleRow.getCell(1).value = `Packet Stock & History Report (${today})`;
        titleRow.getCell(1).font = { bold: true, size: 12 };
        worksheet.mergeCells(`A${titleRow.number}:H${titleRow.number}`);
        titleRow.getCell(1).alignment = { vertical: "middle", horizontal: "center" };

        rowIndex++;

        /* =========================
           LOT / PACKET INFO
        ========================= */
        const lotRow = worksheet.getRow(rowIndex++);
        lotRow.getCell(1).value = isMfgNo ? "MFG Lot No :" : "Lot No :";
        lotRow.getCell(1).font = { bold: true };
        lotRow.getCell(2).value = lotNo;

        lotRow.getCell(4).value = isMfgNo ? "MFG Packet No :" : "Packet No :";
        lotRow.getCell(4).font = { bold: true };
        lotRow.getCell(5).value = pktNo;

        rowIndex++;
        const sumryRow = worksheet.getRow(rowIndex++);
        sumryRow.getCell(1).value = `Stock Summary`;
        sumryRow.getCell(1).font = { bold: true, size: 12 };
        worksheet.mergeCells(`A${sumryRow.number}:H${sumryRow.number}`);
        sumryRow.getCell(1).alignment = { vertical: "middle", horizontal: "center" };
        rowIndex++;

        /* =========================
           STOCK TABLE
        ========================= */
        data?.stkData?.forEach((ele) => {
            // Row 1: Item Info
            const itemRow = worksheet.getRow(rowIndex++);
            itemRow.values = [
                "Item", ele.ItemName,
                "Shape", ele.ShapeName,
                "Size", ele.BWeight,
                "Rate",
                ele.BRate > 0 ? ele.BRate.toFixed(2) : "",
                ele.BRated > 0 ? " | $" + ele.BRated.toFixed(2) : ""
            ];
            // Bold headers
            [1, 3, 5, 7].forEach(c => itemRow.getCell(c).font = { bold: true });

            // Row 2: Location Info
            const locRow = worksheet.getRow(rowIndex++);
            locRow.values = [
                "Location", ele.StkAtName,
                "Color", ele.ColorName,
                "Purity", ele.PurityName,
                "Lab", ele.LabName,
                "Certi NO.", ele.ReportNo
            ];
            [1, 3, 5, 7, 9].forEach(c => locRow.getCell(c).font = { bold: true });

            rowIndex++;
        });

        /* =========================
           PACKET HISTORY HEADER
        ========================= */
        const headerTitleRow = worksheet.getRow(rowIndex++);
        headerTitleRow.getCell(1).value = "Packet History";
        headerTitleRow.getCell(1).font = { bold: true, size: 12 };
        worksheet.mergeCells(`A${headerTitleRow.number}:H${headerTitleRow.number}`);
        headerTitleRow.getCell(1).alignment = { horizontal: "center" };
        rowIndex++;

        const pktHeaderRow = worksheet.getRow(rowIndex++);
        pktHeaderRow.values = CurrencySetting && CurrencySetting != 'RS' ? ["#", "Process", "Date", "Party", "Weight", "Rate($)", "Amount($)", "Rate", "Amount",]
            : ["#", "Process", "Date", "Party", "Weight", "Rate($)", "Amount($)", "Rate", "Amount"];
        pktHeaderRow.eachCell(cell => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: "center" };
            cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFDBEAFF" } };
            cell.border = {
                top: { style: "thin" }, bottom: { style: "thin" },
                left: { style: "thin" }, right: { style: "thin" }
            };
        });

        pktData?.forEach((ele, index) => {
            const pktRow = worksheet.getRow(rowIndex++);
            pktRow.values = [
                index + 1,
                ele.EntryType,
                new Date(ele.EDate).toLocaleDateString(),
                ele.PartyName || "-",
                ele.Weight,
                CurrencySetting && CurrencySetting != 'RS' ? ele.RateD > 0 ? ele.RateD.toFixed(2) : "-" : "",
                CurrencySetting && CurrencySetting != 'RS' ? ele.AmountD > 0 ? ele.AmountD.toFixed(2) : "-" : "",
                ele.Rate > 0 ? ele.Rate.toFixed(2) : "-",
                ele.Amount > 0 ? ele.Amount.toFixed(2) : "-"
            ];
            pktRow.eachCell(cell => {
                cell.border = {
                    top: { style: "thin" }, bottom: { style: "thin" },
                    left: { style: "thin" }, right: { style: "thin" }
                };
            });
        });

        /* =========================
           FOOTER (Page number not supported in Excel, add date)
        ========================= */
        rowIndex += 2;
        const footerRow = worksheet.getRow(rowIndex++);
        footerRow.getCell(1).value = `Generated on: ${new Date().toLocaleDateString()}`;
        worksheet.mergeCells(`A${footerRow.number}:H${footerRow.number}`);
        footerRow.getCell(1).alignment = { horizontal: "left" };
        footerRow.getCell(1).font = { italic: true };

        /* =========================
           SAVE FILE
        ========================= */
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: "application/octet-stream" });
        saveAs(blob, `Lot-${lotNo}_Pkt-${pktNo}.xlsx`);
    };

    // useEffect(() => {
    //     funLoadData();
    // }, [isMfgNo])

    // const exportColumns = [
    //     {
    //         name: "Entry Type",
    //         uid: "EntryType",
    //     },
    //     {
    //         name: "Party NAME",
    //         uid: "PartyName",
    //     },

    //     {
    //         name: "Weight",
    //         uid: "Weight",
    //         type: COLUMN_TYPE.number
    //     },
    //     {
    //         name: "Rate",
    //         uid: "Rate",
    //         type: COLUMN_TYPE.number
    //     },

    //     {
    //         name: "Rate ($)",
    //         uid: "RateD",
    //         type: COLUMN_TYPE.number
    //     },
    //     {
    //         name: "Date",
    //         uid: "EDate",
    //         type: COLUMN_TYPE.date
    //     },


    // ]
    // const [exportCols, setExportCols] = useState(exportColumns)

    // let downloadDataFooter = {
    //     EntryType: "",
    //     PartyName: "",
    //     Weight: "",
    //     Rate: "",
    //     RateD: "",
    //     EDate: "",
    // }
    // const [exportFooter, setExportFooter] = useState(downloadDataFooter)
    // const INITIAL_VISIBLE_COLUMNS = ["EntryType", "PartyName", "Weight", "Rate", "RateD", "EDate"]
    // const [initialColumn, setInitialColumn] = useState(INITIAL_VISIBLE_COLUMNS)
    // const columns = [
    //     { name: "Entry Type", uid: "EntryType", sortable: true, align: COLUMN_ALIGN_TYPE.center },
    //     { name: "Party Name", uid: "PartyName", sortable: true, align: COLUMN_ALIGN_TYPE.center },
    //     { name: "Weight", uid: "Weight", sortable: true, align: COLUMN_ALIGN_TYPE.center, type: COLUMN_TYPE.number },
    //     { name: "Rate", uid: "Rate", sortable: true, align: COLUMN_ALIGN_TYPE.center, type: COLUMN_TYPE.number },
    //     { name: "Rate ($)", uid: "RateD", sortable: true, align: COLUMN_ALIGN_TYPE.center, type: COLUMN_TYPE.number },
    //     { name: "Date", uid: "EDate", sortable: true, align: COLUMN_ALIGN_TYPE.center, type: COLUMN_TYPE.date },
    // ];

    const handleFilter = (e) => {
        e.preventDefault()
        funLoadData(isMfgNo)
    }
    // useEffect(() => {
    //     if (CurrencySetting && CurrencySetting != "") {
    //         let AmtColumn = ""
    //         if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS)
    //             AmtColumn = "RateD"
    //         else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar)
    //             AmtColumn = "Rate"
    //         else {
    //             setInitialColumn(INITIAL_VISIBLE_COLUMNS)
    //             setExportCols(exportColumns)
    //             setExportFooter(downloadDataFooter)
    //         }

    //         if (AmtColumn != "") {
    //             const filterIniCol = initialColumn.filter(ele => ele != AmtColumn)
    //             const filterExpCol = exportColumns.filter((ele) => ele.uid != AmtColumn)
    //             //let footerCol = AmtColumn == 'NetAmtD' ? 'Amount$' : 'Amount'

    //             const filterExpFooter = Object.keys(downloadDataFooter).filter((ele) => ele != AmtColumn)
    //             setExportCols(filterExpCol)
    //             setInitialColumn(filterIniCol)
    //             setExportFooter(filterExpFooter)
    //         }
    //     }
    // }, [CurrencySetting])

    const tdinfo = 'px-2 py-1 bg-lime-50 text-lime-700 border-b-2 border-white'
    const tdhead = 'px-2 py-1 font-semibold bg-blue-50 border-b-2 border-white text-gray-600'
    if (isPending) { return <LoadingCard /> };
    if (isError) return <ErrorCard />;

    return (
        <div>
            <MainContainer pageName="Packet Information" breadcrumbs={["Reports & view", "Packet Information"]}>
                <Card shadow="sm" radius="sm" className="mb-3 h-full">
                    <CardBody className="px-2 py-5">
                        <form onSubmit={handleFilter} >
                            <div className="flex  items-center gap-5">
                                {/* date */}

                                <Input type="text" isRequired
                                    classNames={{ label: "font-bold text-xs uppercase" }}
                                    className=""
                                    variant="underlined" label="lot No" onChange={(e) => setLotNo(e.target.value)} value={lotNo}></Input>
                                <Input type="text" isRequired className=""
                                    classNames={{ label: "font-bold text-xs uppercase" }}
                                    variant="underlined" label="Packet No" onChange={(e) => setPktNo(e.target.value)} value={pktNo}></Input>

                                <Checkbox isSelected={isMfgNo} onValueChange={handleChkChange}
                                    color="primary" variant="flat"
                                    classNames={{ "label": "text-orange-700 text-sm font-semibold " }}
                                    className="py-2 px-2 w-full rounded-md bg-orange-100 border-blue-200 border-0" label="gfu"
                                >
                                    Manufacturing No
                                </Checkbox>
                                <Button
                                    size="sm"
                                    color="primary"
                                    startContent={<FontAwesomeIcon icon={faMagnifyingGlass} />}
                                    // onPress={handleFilter}
                                    type="submit"
                                    className="w-full bg-blue-800 font-semibold"
                                //isLoading={isPending}
                                >
                                    Find
                                </Button>

                            </div>
                        </form>
                    </CardBody>
                </Card>
                <div className="bg-white p-2 border-2">
                    {
                        pktData && pktData.length > 0 && (
                            <div>
                                <div className="flex gap-5 justify-end mb-2 ">
                                    <button
                                        onClick={exportPDF}
                                        className="px-2 py-1 bg-green-600 text-white rounded-md text-sm font-semibold"
                                    >
                                        Export PDF
                                    </button>
                                    <button
                                        onClick={exportExcel}
                                        className="px-2 py-1 bg-red-600 text-white rounded-md text-sm font-semibold"
                                    >
                                        Export Excel
                                    </button>
                                </div>

                                <div className="mb-3 p-1 rounded-md bg-orange-100 border border-orange-300">
                                    <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-sm font-semibold uppercase">
                                        <div>
                                            <span className="text-gray-600">{isMfgNo ? "Mfg Lot No :" : "Lot No :"}</span>{" "}
                                            <span className="text-orange-800">{lotNo}</span>
                                        </div>

                                        <div>
                                            <span className="text-gray-600">{isMfgNo ? "Mfg Packet No :" : "Packet No :"}</span>{" "}
                                            <span className="text-orange-800">{pktNo}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }

                    {
                        pktData && pktData.length > 0 && data && Object.keys(data).length > 0 && data?.stkData ? <div className="border-1 border-lime-500"><Chip
                            startContent={<FontAwesomeIcon icon={faGem} ></FontAwesomeIcon>} variant="light" radius="none"
                            className="bg-llime-50 text-orange-700 w-full uppercase text-sm font-semibold">Stock Summary</Chip>
                            {
                                data?.stkData.map((ele) => {
                                    return (
                                        <div>

                                            <table className="w-full  uppercase font-semibold   border border-red-200 rounded-md overflow-hidden text-sm">
                                                <tbody>
                                                    <tr className="">
                                                        <td className={tdhead}>Item :</td>
                                                        <td className={tdinfo}>{ele.ItemName}</td>
                                                        <td className={tdhead}>Shape :</td>
                                                        <td className={tdinfo}>{ele.ShapeName}</td>
                                                        <td className={tdhead}>Size :</td>
                                                        <td className={tdinfo}>{ele.BWeight}</td>
                                                        <td className={tdhead}>Rate :</td>
                                                        <td className={tdinfo}>{ele.BRate > 0 ? "₹ " + ele.BRate.toFixed(2) : ""}
                                                            {ele.BRated > 0 ? " | $" + ele.BRated.toFixed(2) : ""}
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td className={tdhead}>Location :</td>
                                                        <td className={tdinfo}>{ele.StkAtName}</td>
                                                        <td className={tdhead}>Color :</td>
                                                        <td className={tdinfo}>{ele.ColorName}</td>
                                                        <td className={tdhead}>Purity :</td>
                                                        <td className={tdinfo}>{ele.PurityName}</td>
                                                        <td className={tdhead}>Lab :</td>
                                                        <td className={tdinfo}>{ele.LabName}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className={tdhead}>Certificate :</td>
                                                        <td className={tdinfo}>
                                                            <a href={ele?.Lab && ele?.Lab != "" ? ele?.Lab.toUpperCase() == "IGI" ? 'https://www.igi.org/reports/verify-your-report?r=' + ele?.ReportNo || ""
                                                                : ele?.Lab.toUpperCase() == "GIA" ? 'https://www.gia.edu/report-check?reportno=' + ele?.ReportNo : "" : ""} target="_blank" style={{ color: "#0d47a1" }} >{ele?.ReportNo || ""}</a>
                                                        </td>
                                                        <td className={tdhead}>Video Link :</td>
                                                        <td colSpan={5} className={tdinfo}> <a href={ele.VideoFile} target="blank" >{ele.VideoFile}</a></td>
                                                    </tr>

                                                </tbody>
                                            </table>
                                        </div>
                                    )
                                })
                            }
                        </div> : ""

                    }

                    {
                        pktData && pktData.length > 0 && (
                            <div className="mt-3 overflow-x-auto">

                                <table className="w-full uppercase font-semibold text-xs border border-blue-200 rounded-md overflow-hidden">
                                    <thead className="bg-blue-100 text-blue-800">
                                        <tr>
                                            <th className="px-2 py-1 border">#</th>
                                            <th className="px-2 py-1 border">Process</th>
                                            <th className="px-2 py-1 border">Date</th>
                                            <th className="px-2 py-1 border">Party</th>
                                            <th className="px-2 py-1 border text-right">Weight</th>

                                            {CurrencySetting && CurrencySetting != "RS" ? <>
                                                <th className="px-2 py-1 border text-right">$ Rate</th>
                                                <th className="px-2 py-1 border text-right">$ Amount </th></> : ""}
                                            <th className="px-2 py-1 border text-right">Rate</th>
                                            <th className="px-2 py-1 border text-right">Amount</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {pktData.map((ele, index) => (
                                            <tr
                                                key={index}
                                                className="odd:bg-white even:bg-blue-50"
                                            >
                                                <td className="px-2 py-1 border text-center">
                                                    {index + 1}
                                                </td>

                                                <td className="px-2 py-1 border">
                                                    {ele.EntryType}
                                                </td>

                                                <td className="px-2 py-1 border">
                                                    {new Date(ele.EDate).toLocaleDateString()}
                                                </td>

                                                <td className="px-2 py-1 border">
                                                    {ele.PartyName || "-"}
                                                </td>

                                                <td className="px-2 py-1 border text-right">
                                                    {ele.Weight}
                                                </td>


                                                {CurrencySetting && CurrencySetting != "RS" ? <>
                                                    <td className="px-2 py-1 border text-right">
                                                        {ele.RateD > 0 ? ele.RateD.toFixed(2) : "-"}
                                                    </td>
                                                    <td className="px-2 py-1 border text-right">
                                                        {ele.RateD > 0 ? (ele.AmountD).toFixed(2) : "-"}
                                                    </td></> : ""
                                                }
                                                <td className="px-2 py-1 border text-right">
                                                    {ele.Rate > 0 ? ele.Rate.toFixed(2) : "-"}
                                                </td>
                                                <td className="px-2 py-1 border text-right">
                                                    {ele.Rate > 0 ? (ele.Amount).toFixed(2) : "-"}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )
                    }


                </div>



            </MainContainer>


        </div>
    );
};

export default PacketInformationReport;
